export default "__VITE_PUBLIC_ASSET__17994c81__"